<div class="row page-header">
    <div class="col-12">
        <h1>Bid Analytics <small>View historical bid information to improve future bidding</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Win Rates</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <wj-combo-box
                                        name="selectedTimeunit"
                                        [itemsSource]="timeunits"
                                        (selectedIndexChanged)="refresh()"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [(ngModel)]="selectedTimeunit"
                                    >
                                    </wj-combo-box>
                                    <wj-combo-box
                                        name="selectedCompetitor"
                                        [itemsSource]="competitorMap"
                                        (selectedIndexChanged)="refresh()"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [isRequired]="false"
                                        [placeholder]="'Optional Competitor'"
                                        [(selectedIndex)]="selectedCompetitor"
                                    >
                                    </wj-combo-box>
                                    <!--<action-toolbar-count [grid]="analyticGrid"></action-toolbar-count>
                                    <action-toolbar-search name="search" [(ngModel)]="analyticGrid.filter"></action-toolbar-search>-->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="row">
                            <div class="col-12">
                                <h4>{{ vanConHeader }}</h4>
                                <wj-flex-grid
                                    id="timeSeriesGrid"
                                    #tsGrid
                                    style="height: 375px"
                                    (initialized)="timeSeriesGrid.initialize(tsGrid)"
                                    (destroy)="timeSeriesGrid.destroy()"
                                    [itemsSource]="timeSeriesGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="90"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Bids'" [binding]="'totalBidCount'" [width]="70"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Avg # of Bidders'"
                                        [binding]="'avgNumBidders'"
                                        [width]="120"
                                        [format]="'N2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bid $'"
                                        [binding]="'totalBidAmount'"
                                        [width]="'*'"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Avg Bid $'"
                                        [binding]="'avgBidAmount'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Wins'" [binding]="'totalWinCount'" [width]="80"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win $'"
                                        [binding]="'totalWinAmount'"
                                        [width]="'*'"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win Ratio'"
                                        [binding]="'totalWinCountRatio'"
                                        [width]="100"
                                        [format]="'P'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win $ Ratio'"
                                        [binding]="'totalWinAmountRatio'"
                                        [width]="100"
                                        [format]="'P'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Unclaimed Value'"
                                        [binding]="'unclaimedValue'"
                                        [width]="130"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px">
                            <div class="col-12">
                                <h4>{{ competitorHeader }}</h4>
                                <wj-flex-grid
                                    id="compTimeSeriesGrid"
                                    #ctsGrid
                                    appAutoSize
                                    (initialized)="compTimeSeriesGrid.initialize(ctsGrid)"
                                    (destroy)="compTimeSeriesGrid.destroy()"
                                    [itemsSource]="compTimeSeriesGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Date'"
                                        [binding]="'date'"
                                        [width]="90"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bids'"
                                        [binding]="'totalBidCount'"
                                        [width]="80"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bid $'"
                                        [binding]="'compBidAmount'"
                                        [width]="'*'"
                                        [format]="'C0'"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Wins'"
                                        [binding]="'compWinCount'"
                                        [width]="80"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win $'"
                                        [binding]="'compWinAmount'"
                                        [width]="'*'"
                                        [format]="'C0'"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win Ratio'"
                                        [binding]="'compWinCountRatio'"
                                        [width]="100"
                                        [format]="'P'"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win $ Ratio'"
                                        [binding]="'compWinAmountRatio'"
                                        [width]="100"
                                        [format]="'P'"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Unclaimed Value'"
                                        [binding]="'compUnclaimedValue'"
                                        [width]="140"
                                        [format]="'C0'"
                                        [visible]="selectedCompetitor > 0"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <wj-flex-chart
                            [itemsSource]="timeSeriesGrid.view"
                            [bindingX]="'date'"
                            [chartType]="'Column'"
                            style="height: 300px"
                            [header]="'Bids vs Wins'"
                        >
                            <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                            <wj-flex-chart-axis
                                [wjProperty]="'axisY'"
                                [title]="'Total Bids'"
                                [min]="0"
                                [max]="maxBidRange"
                            ></wj-flex-chart-axis>
                            <wj-flex-chart-series [binding]="'totalBidCount'" [name]="'Bids'"></wj-flex-chart-series>
                            <wj-flex-chart-series [binding]="'totalWinCount'" [name]="'Wins'"></wj-flex-chart-series>
                            <wj-flex-chart-data-label content="{value}" position="Top"></wj-flex-chart-data-label>
                        </wj-flex-chart>

                        <wj-flex-chart
                            #amountChart
                            [itemsSource]="timeSeriesGrid.view"
                            [bindingX]="'date'"
                            [chartType]="'Column'"
                            style="height: 300px"
                            [header]="'Bids Amount vs Win Amount'"
                        >
                            <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                            <wj-flex-chart-axis
                                [wjProperty]="'axisY'"
                                [title]="'Total $ Amounts'"
                                [min]="0"
                                [max]="maxAmountRange"
                                [itemFormatter]="amountChartItemAxisFormatter"
                            ></wj-flex-chart-axis>
                            <wj-flex-chart-series [binding]="'totalBidAmount'" [name]="'Bids'"></wj-flex-chart-series>
                            <wj-flex-chart-series [binding]="'totalWinAmount'" [name]="'Wins'"></wj-flex-chart-series>
                            <wj-flex-chart-data-label content="{amountLabel(value)}" position="Top"></wj-flex-chart-data-label>
                        </wj-flex-chart>

                        <wj-flex-chart
                            #ratioChart
                            [itemsSource]="timeSeriesGrid.view"
                            [bindingX]="'date'"
                            [chartType]="'Column'"
                            style="height: 300px"
                            [header]="'Ratios'"
                        >
                            <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                            <wj-flex-chart-axis
                                [wjProperty]="'axisY'"
                                [title]="'Ratio'"
                                [min]="0"
                                [max]="maxRationRange"
                                [format]="'P'"
                            ></wj-flex-chart-axis>
                            <wj-flex-chart-series [binding]="'totalWinCountRatio'" [name]="'Win # Ratio'"></wj-flex-chart-series>
                            <wj-flex-chart-series [binding]="'totalWinAmountRatio'" [name]="'Win $ Ratio'"></wj-flex-chart-series>
                        </wj-flex-chart>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Bid Type Analytics</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-8">
                        <div class="row action-toolbar" style="margin-top: 10px">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="analyticGrid"></action-toolbar-count>
                                    <action-toolbar-search name="search" [(ngModel)]="analyticGrid.filter"></action-toolbar-search>

                                    <div class="input-header-group">
                                        <span class="input-header">Bid Date (Start)</span>
                                        <wj-input-date
                                            [(ngModel)]="startDate"
                                            (ngModelChange)="refresh()"
                                            name="startDate"
                                            style="width: 125px; height: 32px; margin-top: 4px"
                                        ></wj-input-date>
                                    </div>

                                    <div class="input-header-group">
                                        <span class="input-header">Bid Date (End)</span>
                                        <wj-input-date
                                            [(ngModel)]="endDate"
                                            (ngModelChange)="refresh()"
                                            name="endDate"
                                            style="width: 125px; height: 32px; margin-top: 4px"
                                        ></wj-input-date>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="analyticGrid"
                                    #analGrid
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="analyticGrid.initialize(analGrid)"
                                    (destroy)="analyticGrid.destroy()"
                                    [itemsSource]="analyticGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'BidType'"
                                        [binding]="'bidType'"
                                        [width]="250"
                                        [format]="'D'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Success'"
                                        [binding]="'successRatio'"
                                        [width]="110"
                                        [format]="'P0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Avg Bidders'"
                                        [binding]="'avgBidders'"
                                        [width]="100"
                                        [format]="'N1'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Avg Lost By'"
                                        [binding]="'avgLostBy'"
                                        [width]="100"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Avg Won By'"
                                        [binding]="'avgWonBy'"
                                        [width]="100"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <!--<wj-flex-grid-column [header]="'Profit Margin'" [binding]="'profitMargin'" [width]="100" [format]="'P2'"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Sum'" [binding]="'sumPercent'" [width]="100" [format]="'P2'"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column [header]="'Count'" [binding]="'count'" [width]="100"></wj-flex-grid-column>
                                    <!--<wj-flex-grid-column [header]="'Equip Cost'" [binding]="'equipCostPercent'" [width]="100" [format]="'P2'"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Labor'" [binding]="'laborPercent'" [width]="100" [format]="'P2'"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column
                                        [header]="'Volume'"
                                        [binding]="'volume'"
                                        [width]="115"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Market Share'"
                                        [binding]="'marketShare'"
                                        [width]="105"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="analGrid"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <!--<action-toolbar-count [grid]="analyticGrid"></action-toolbar-count>
                                    <action-toolbar-search name="search" [(ngModel)]="analyticGrid.filter"></action-toolbar-search>-->
                                </form>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 39px">
                            <div class="col-12">
                                <wj-flex-chart
                                    [itemsSource]="winPercentData"
                                    [bindingX]="'key'"
                                    [chartType]="'Spline'"
                                    [header]="'Bidder Curve'"
                                >
                                    <wj-flex-chart-legend [position]="'None'"></wj-flex-chart-legend>
                                    <wj-flex-chart-axis [wjProperty]="'axisX'" [title]="'Number of Bidders'"></wj-flex-chart-axis>
                                    <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Probability of Win'"></wj-flex-chart-axis>
                                    <wj-flex-chart-series [binding]="'value'" [name]="'Average Low'"></wj-flex-chart-series>
                                </wj-flex-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Competitor Analytics</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="competitionGrid"></action-toolbar-count>
                                    <!--<action-toolbar-buttons [grid]="competitionGrid" [canEdit]="canEdit" [showAdd]="true" [showEdit]="true" [showDelete]="true"></action-toolbar-buttons>-->
                                    <action-toolbar-search name="search" [(ngModel)]="competitionGrid.filter"></action-toolbar-search>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="compGrid"
                                    #compGrid
                                    appAutoSize
                                    (initialized)="competitionGrid.initialize(compGrid)"
                                    (destroy)="competitionGrid.destroy()"
                                    [itemsSource]="competitionGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="300"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Wins'" [binding]="'wins'" [width]="110"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Second Places'"
                                        [binding]="'seconds'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false">
            <a ngbNavLink>Seasonal By Job Type</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="competitionGrid"></action-toolbar-count>
                                    <!--<action-toolbar-buttons [grid]="competitionGrid" [canEdit]="canEdit" [showAdd]="true" [showEdit]="true" [showDelete]="true"></action-toolbar-buttons>-->
                                    <action-toolbar-search name="search" [(ngModel)]="competitionGrid.filter"></action-toolbar-search>
                                    <wj-multi-select
                                        name="selectedSeasons"
                                        [(ngModel)]="selectedSeasons"
                                        [showSelectAllCheckbox]="true"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [placeholder]="'Select Quarter(s)'"
                                        [headerFormat]="'{count:n0} items'"
                                        [itemsSource]="seasonsMap"
                                    >
                                    </wj-multi-select>
                                    <wj-multi-select
                                        name="selectedProjectTypes"
                                        [(ngModel)]="selectedProjectTypes"
                                        [showSelectAllCheckbox]="true"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [placeholder]="'Select Job Type(s)'"
                                        [headerFormat]="'{count:n0} items'"
                                        [itemsSource]="projectTypesMap"
                                    >
                                    </wj-multi-select>
                                    <wj-multi-select
                                        name="selecteCompCounts"
                                        [(ngModel)]="selecteCompCounts"
                                        [showSelectAllCheckbox]="true"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [placeholder]="'Select # of competitors'"
                                        [headerFormat]="'{count:n0} items'"
                                        [itemsSource]="compCountMap"
                                    >
                                    </wj-multi-select>
                                    <button type="button" class="btn btn-sm btn-secondary" (click)="getSeasonalBidReport()">
                                        Get Summarized Report
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="seasGrid"
                                    #seasGrid
                                    appAutoSize
                                    (initialized)="seasonalGrid.initialize(seasGrid)"
                                    (destroy)="seasonalGrid.destroy()"
                                    [itemsSource]="seasonalGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Metric'" [binding]="'metric'" [width]="'*'"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win Rate'"
                                        [binding]="'winRate'"
                                        [width]="'*'"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win Spread'"
                                        [binding]="'winSpread'"
                                        [width]="'*'"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Non-Win Spread'"
                                        [binding]="'nonWinSpread'"
                                        [width]="'*'"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'High/Low Spread'"
                                        [binding]="'highLowSpread'"
                                        [width]="'*'"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Bid Counts'" [binding]="'bidCount'" [width]="'*'"></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="5" [destroyOnHide]="false">
            <a ngbNavLink>Bid What If</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <wj-multi-select
                                        name="selectedProjectTypesWhatIf"
                                        [(ngModel)]="selectedProjectTypesWhatIf"
                                        [showSelectAllCheckbox]="true"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [placeholder]="'Select Job Type(s)'"
                                        [headerFormat]="'{count:n0} items'"
                                        [itemsSource]="projectTypesMapWhatIf"
                                    >
                                    </wj-multi-select>
                                    <input
                                        class="form-control"
                                        type="text"
                                        placeholder="What If Percentages"
                                        [(ngModel)]="whatIf"
                                        style="width: 1200px; height: 32px"
                                        name="whatIf"
                                    />
                                    <button
                                        id="btnCancel"
                                        type="button"
                                        class="btn btn-sm btn-secondary"
                                        (click)="calculateWhatIf()"
                                        [disabled]="isSaving"
                                    >
                                        Calculate
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridWhatIf"
                                    #gridWhatIf
                                    style="height: 300px"
                                    (initialized)="whatIfGrid.initialize(gridWhatIf)"
                                    (destroy)="whatIfGrid.destroy()"
                                    [itemFormatter]="whatIfItemFormatter"
                                    [itemsSource]="whatIfGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Percent'"
                                        [binding]="'whatIfPercent'"
                                        [format]="'P2'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Win Count'" [binding]="'wins'" [width]="110"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Loss Count'" [binding]="'loses'" [width]="110"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Win Revenue'"
                                        [binding]="'winRevenue'"
                                        [format]="'C0'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Revenue Delta'"
                                        [binding]="'delta'"
                                        [format]="'C0'"
                                        [width]="110"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Total Mark Up'"
                                        [binding]="'markUp'"
                                        [format]="'C0'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Mark Up Delta'"
                                        [binding]="'deltaMarkUp'"
                                        [format]="'C0'"
                                        [width]="110"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Total Overhead Add On'"
                                        [binding]="'totalOverheadAddOn'"
                                        [format]="'C0'"
                                        [width]="110"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Total Equip Op Exp'"
                                        [binding]="'totalEquipOpExp'"
                                        [format]="'C0'"
                                        [width]="110"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Total CO Equip'"
                                        [binding]="'totalCoEquip'"
                                        [format]="'C0'"
                                        [width]="110"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 5px">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridWhatIfDetails"
                                    #gridWhatIfDetails
                                    appAutoSize
                                    (initialized)="whatIfGridDetails.initialize(gridWhatIfDetails)"
                                    (destroy)="whatIfGridDetails.destroy()"
                                    [itemFormatter]="whatIfGridDetailsItemFormatter"
                                    [itemsSource]="whatIfGridDetails.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="300"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'New VanCon'"
                                        [binding]="'vanCon'"
                                        [format]="'C0'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Old VanCon'"
                                        [binding]="'oldVanCon'"
                                        [format]="'C0'"
                                        [width]="120"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'New Low'"
                                        [binding]="'low'"
                                        [format]="'C0'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Old Low'"
                                        [binding]="'oldLow'"
                                        [format]="'C0'"
                                        [width]="120"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'New Mark Up'"
                                        [binding]="'markUp'"
                                        [format]="'C0'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Old Mark Up'"
                                        [binding]="'oldMarkUp'"
                                        [format]="'C0'"
                                        [width]="120"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Overhead Add On'"
                                        [binding]="'overheadAddOn'"
                                        [width]="110"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Equip OP Exp'"
                                        [binding]="'equipOpExp'"
                                        [width]="100"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'CO Equip'"
                                        [binding]="'coEquip'"
                                        [width]="100"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="6" [destroyOnHide]="false">
            <a ngbNavLink>Estimates Vs Actuals</a>
            <ng-template ngbNavContent>
                <app-estimate-vs-actual [active]="active"> </app-estimate-vs-actual>
            </ng-template>
        </li>
        <li [ngbNavItem]="7" [destroyOnHide]="false">
            <a ngbNavLink>Margin Estimates Vs Actuals</a>
            <ng-template ngbNavContent>
                <app-margin-est-vs-actual [active]="active"> </app-margin-est-vs-actual>
            </ng-template>
        </li>
        <li [ngbNavItem]="8" [destroyOnHide]="false">
            <a ngbNavLink>Adjusted Gross Margin %</a>
            <ng-template ngbNavContent>
                <app-adj-gross-margin-pct [active]="active"> </app-adj-gross-margin-pct>
            </ng-template>
        </li>
        <li [ngbNavItem]="9" [destroyOnHide]="false">
            <a ngbNavLink>Won By Department</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar" style="margin-top: 10px">
                            <div class="col-12">
                                <form class="form-inline">
                                    <wj-combo-box
                                        name="wonByDeptTimeunit"
                                        [itemsSource]="timeunits"
                                        (selectedIndexChanged)="refreshWonByDept()"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [(ngModel)]="wonByDeptTimeunit"
                                    >
                                    </wj-combo-box>
                                    <div class="input-header-group">
                                        <span class="input-header">Start Date</span>
                                        <wj-input-date
                                            [(ngModel)]="wonByDeptStartDate"
                                            (ngModelChange)="refreshWonByDept()"
                                            name="wonByDeptStartDate"
                                            style="width: 125px; height: 32px; margin-top: 4px"
                                        ></wj-input-date>
                                    </div>
                                    <div class="input-header-group">
                                        <span class="input-header">End Date</span>
                                        <wj-input-date
                                            [(ngModel)]="wonByDeptEndDate"
                                            (ngModelChange)="refreshWonByDept()"
                                            name="wonByDeptEndDate"
                                            style="width: 125px; height: 32px; margin-top: 4px"
                                        ></wj-input-date>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="wonByDeptGrid"
                                    #wbdGrid
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="wonByDeptGrid.initialize(wbdGrid)"
                                    (destroy)="wonByDeptGrid.destroy()"
                                    [itemsSource]="wonByDeptGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="wbdGrid"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
